import { render, staticRenderFns } from "./PublisherDropdown.vue?vue&type=template&id=149036d1&scoped=true&"
import script from "./PublisherDropdown.vue?vue&type=script&lang=js&"
export * from "./PublisherDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PublisherDropdown.vue?vue&type=style&index=0&id=149036d1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149036d1",
  null
  
)

export default component.exports